import axios from 'axios';
import { loginreq, req,downloReq,userreq,_get } from './axiosFun';


// 登录前接口
export const passport = (params) => { return loginreq("get","/mtl/marking/api/main/passport/salt",{}) };
// 登录接口
export const login = (params) => { return loginreq("post", "/mtl/marking/api/main/passport/login", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
export const menunode = (params) => { return req("get", "/mtl/marking/api/main/menu/tree-menu-node?menuAppType=" + params) };
/**
 * 用户管理
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return req("post", "/mtl/marking/api/main/user/page", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("put", "/mtl/marking/api/main/user", params) };
// 用户管理-编辑
export const userEdit = (params) => { return req("post", "/mtl/marking/api/main/user", params) };
// 用户管理-详情
export const userDetails = (params) => { return req("get", "/mtl/marking/api/main/user/" + params) };
// 用户管理-删除用户
export const userDelete = (params) => { return axios.delete("/api/User/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", "/api/User/pwd", params) };
// 用户管理-修改状态
export const userLock = (params) => { return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get("/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", "/api/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get("/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", "/api/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/api/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/api/User/flashCache/" + params, {}) };
//用户身份关联角色
export const getsubAccoun = (userId,subAccountId,params) => { return req("POST", `/mtl/marking/api/main/user/${userId}/${subAccountId}/role`, params) };
//用户密码修改
export const getpassword = (userId,password) => { return req("POST", `/mtl/marking/api/main/user/${userId}/password?password=`+password) };
//用户密码修改
export const getpasswordchange = (userId,oldPassword,newPassword) => { return req("POST", `/mtl/marking/api/main/user/${userId}/password/change?oldPassword=`+oldPassword+'&newPassword='+newPassword) };
export const changemanager = (systemManagerId) => { return req("DELETE", `/mtl/marking/api/main/system-manager/${systemManagerId}`) };
//系统用户列表
export const systemmanager = (params) => { return req("post", "/mtl/marking/api/main/system-manager/page", params) };
export const systemmanagerid = (productIntroductionId) => { return req("GET", `/mtl/marking/api/main/system-manager/${productIntroductionId}`) };
export const systemmanagerSave = (params) => { return req("post", "/mtl/marking/api/main/system-manager/system-manager", params) };
export const systemmanagerEdit = (params) => { return req("PUT", "/mtl/marking/api/main/system-manager/system-manager", params) };
/**
 * 菜单管理
 **/
// 菜单管理-修改菜单状态
export const Modulestate = (params) => { return req("get", "/mtl/marking/api/main/menu/state?menuCode="+ params.menuCode+"&status="+params.status) };
// 菜单管理-根据菜单获取详情
export const ModuleGet = (params) => { return req("get", "/mtl/marking/api/main/menu/" + params) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("get", "/mtl/marking/api/main/menu?pageIndex="+ params.pageIndex+"&pageSize="+params.pageSize+"&parentMenuCode="+params.parentMenuCode+"&name="+params.name) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("put", "/mtl/marking/api/main/menu", params) };
// 菜单管理-新增菜单
export const ModuleAdd = (params) => { return req("post", "/mtl/marking/api/main/menu", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete("/mtl/marking/api/main/menu/" + params ).then(res => res.data) };

/**
 * 角色管理
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return req("get", "/mtl/marking/api/main/role?pageIndex="+ params.pageIndex+"&pageSize="+params.pageSize+"&name="+params.name) };
// 角色管理-保存（编辑）
export const roleSave = (params) => { return req("PUT", "/mtl/marking/api/main/role", params) };
// 角色管理-添加（编辑）
export const roleAdd = (params) => { return req("post", "/mtl/marking/api/main/role", params) };
// 角色管理-详情
export const roleDetails = (params) => { return req("get", "/mtl/marking/api/main/role/" + params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return axios.delete("/api/Role/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return loginreq("get", "/mtl/marking/api/main/menu/tree",{})};
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/RoleRight/save", params) };


/**
 * 经销商管理
 **/
// 经销商管理-获取经销商列表
export const distributorList = (params) => { return req("get", "/mtl/marking/api/main/dealers/list?pageIndex="+ params.pageIndex+"&pageSize="+params.pageSize+"&phoneNumber="+params.phoneNumber+"&name="+params.name) };
// 经销商管理-获取经销商详情
export const distributor = (params) => { return req("get", "/mtl/marking/api/main/dealers/"+ params) };
// 经销商管理-修改经销商详情
export const putDealers = (params) => { return req("put", "/mtl/marking/api/main/dealers", params) };

/**
 * 公司管理
 **/
// 公司管理-获取公司列表
export const deptList = (params) => { return req("post", "/api/Dept/list", params) };
// 公司管理-保存（添加编辑）
export const deptSave = (params) => { return req("post", "/api/Dept/save", params) };
// 公司管理-删除公司
export const deptDelete = (params) => { return axios.get("/api/Dept/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 系统环境变量
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/api/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/api/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };

/**
 * 客户管理
 **/
// 客户管理-获取客户列表
export const getCustomerList = (params) => { return _get("/mtl/marking/api/main/customer_back/search_customer",params) };
// 客户管理-获取客户详情
export const getCustomerInfo = (customerId) => { return req("GET", `/mtl/marking/api/main/customer_back/${customerId}`) };
// 客户管理-修改客户详情
export const modifyCustomerInfo = (params) => { return req("PUT", `/mtl/marking/api/main/customer_back`, params) };
// 、、-获取经销商列表
export const getDealersList = (params) => { return _get("/mtl/marking/api/main/dealers/list",params) };
// 客户管理-后台分配客户给经销商
export const customerAssign = (params) => { return req("POST", `/mtl/marking/api/main/customer_back/customer_assign`, params) };


// WEBPACK FOOTER //
// ./src/api/userMG.js